import React from 'react';

export const FormikError = ({ name, formik }) => {
  const { errors, touched } = formik;

  return errors ? (
    <div className="text-danger mt-1 ml-1">{touched[name] && errors[name]}</div>
  ) : null;
};
